// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__ztCYe","icon":"SearchForm_icon__wnwW_","input":"SearchForm_input__Z2SnT"};